import { Stack } from 'components/Stack';
import { FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { ReturnProof } from '@pperform/pp-data-mappers';
import { AttachmentItem } from '../AttachmentItem';
import { Title } from './AttachmentSection.styles';

interface AttachmentsProps {
  attachments?: ReturnProof[];
}
const AttachmentSection: FunctionComponent<AttachmentsProps> = ({
  attachments = [],
}) => {
  const { t } = useTranslation();
  const renderListAttachments = () => {
    if (attachments.length !== 0) {
      return attachments.map((attachment) => (
        <AttachmentItem attachment={attachment} />
      ));
    }
    return <div>-</div>;
  };

  return (
    <Stack direction="column" gap={8} isFullWidth>
      <Title>{t('RETURN_ATTACHMENTS')}:</Title>
      {renderListAttachments()}
    </Stack>
  );
};

export { AttachmentSection };
